module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-nav', [_c('vbl-nav-item', {
    attrs: {
      "to": "/vblNav"
    }
  }, [_vm._v("首页")]), _c('vbl-nav-item', {
    attrs: {
      "to": "/detail"
    }
  }, [_vm._v("详情页")]), _c('vbl-nav-item', {
    attrs: {
      "to": "/edit"
    }
  }, [_vm._v("编辑")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27283bb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblNav/example/vblNavExample.vue
// module id = 251
// module chunks = 0